import { render, staticRenderFns } from "./Criar-Enquete.vue?vue&type=template&id=623f76a3&scoped=true&"
import script from "./Criar-Enquete.vue?vue&type=script&lang=js&"
export * from "./Criar-Enquete.vue?vue&type=script&lang=js&"
import style0 from "./Criar-Enquete.vue?vue&type=style&index=0&id=623f76a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623f76a3",
  null
  
)

component.options.__file = "Criar-Enquete.vue"
export default component.exports